<div class="row">
  <div class="col-2">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-10">
    <app-header></app-header>
    <div class="container" style="margin-top: 100px;">
      <div class="row" style="padding-top: 50px;">
        <!-- <div class="col-9">
          <h3>{{clinicName}}</h3>
        </div> -->
        <div class="col">
          <input placeholder="Search member" (input)="getMembersByName($event)" class="form-control">
        </div>
        <div class="col-md-4 text-center">
          <select class="form-control font-weight-bold" style="text-align-last: center"
          (change)="onChangeClinic($event.target.value)">
          <option *ngFor="
              let clinic of clinicArray;
              let index = index
            " [value]="index">
            {{ clinic.clinicName }}
          </option>
        </select>
      </div>
        <div class="col-3">
          <button class="btn btn-danger" data-toggle="modal" data-target="#exampleModal">Add Members</button>
        </div>
          
      </div>
      <table class="table" style="margin-top: 50px;">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Phone</th>
            <th scope="col">Email</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of members; let i = index">
            <th scope="row">{{i+1}}</th>
            <td (click)="toggleDropdown(i)">{{data.name}}
              <hr *ngIf="dropdownOpen[i]"/>
            <div class="dropdown-content" *ngIf="dropdownOpen[i]">
              <!-- Dropdown content goes here -->
              <label for="startDate">Start Date :</label>
              <p-calendar [(ngModel)]="startDate"  id="startDate" style="z-index: 9999;" (onSelect)="onChangeStartDate($event)" ></p-calendar>
            </div>
          </td>
            <td (click)="toggleDropdown(i)">{{data.phoneNumber}}
              <hr *ngIf="dropdownOpen[i]"/>
              <div class="dropdown-content" *ngIf="dropdownOpen[i]">
                <!-- Dropdown content goes here -->
                <label for="endDate">End Date :</label>
                <p-calendar [(ngModel)]="endDate" [minDate]="startDate"  id="endDate" style="z-index: 9999;" (onSelect)="onChangeEndDate($event)" ></p-calendar>
              </div>
            </td>
            <td (click)="toggleDropdown(i)">{{data.email}}
              <hr *ngIf="dropdownOpen[i]"/>
              <div class="dropdown-content" *ngIf="dropdownOpen[i]">
                <!-- Dropdown content goes here -->
                <a class="btn btn-primary btn-sm"  [routerLink]="['/date-range-table', startDatefinal,endDatefinal,data._id]" target="_blank">Get Record</a>
                <!-- <label for="endDate">End Date</label>
                <p-calendar [(ngModel)]="endDate" [minDate]="startDate"  id="endDate" style="z-index: 9999;" (onSelect)="onChangeEndDate($event)" ></p-calendar> -->
              </div>
            </td>
            <td >

              <h5><i class="fa fa-pencil" aria-hidden="true" style="margin-right: 20px;"></i>
                <i class="fa fa-trash" (click)="deleteMember(data)" aria-hidden="true"></i>
              </h5>
              <hr *ngIf="dropdownOpen[i]"/>
              <div class="dropdown-content" *ngIf="dropdownOpen[i]">
                <!-- Dropdown content goes here -->
                <button class="btn btn-danger btn-sm" (click)="closelistView(i)"><span aria-hidden="true" #cls>&times;</span></button>
                <!-- <label for="endDate">End Date</label>
                <p-calendar [(ngModel)]="endDate" [minDate]="startDate"  id="endDate" style="z-index: 9999;" (onSelect)="onChangeEndDate($event)" ></p-calendar> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
     
      
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" #cls>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form [formGroup]="personForm" (ngSubmit)="addPerson()">
              <input formControlName="name" type="text" autocomplete="off" class="form-control" placeholder="Name"><br>
              <input formControlName="phoneNumber" type="number" autocomplete="off" class="form-control"
                placeholder="Phone Number"><br>
              <input formControlName="email" type="email" autocomplete="off" class="form-control"
                placeholder="Email"><br>
              <hr />
              <button type="submit" class="btn btn-primary pull-right" style="background-color: #00cec9;">Add</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



